import { FormControl, FormHelperText, FormLabel } from '@mui/material';
import TextField from '@mui/material/TextField';
import * as React from 'react';
import { outlinedFieldStyles } from "./fieldStyles";


export default function CustomTextField({ values, onChange, error, placeholder, type, title, required, rows, multiline, InputProps, disabled, sx }) {

    return (
        <>
            <FormControl variant="outlined" fullWidth>
                {(title || required) && <FormLabel>{title}{required && <span style={{ color: "red" }}>*</span>}</FormLabel>}
                <TextField
                    size="small"
                    placeholder={placeholder}
                    type={type}
                    multiline={multiline}
                    {...(multiline && rows ? { rows } : {})}
                    InputProps={InputProps}
                    required={required}
                    value={values}
                    disabled={disabled}
                    variant="outlined"
                    sx={[outlinedFieldStyles, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
                    onChange={(e) => onChange(e)}
                />
            </FormControl>
            {error && <FormHelperText sx={{ color: "red" }}>{error || ""}</FormHelperText>}
        </>


    );
}
